import * as React from 'react'
import { Portal } from './portal'
import { Backdrop } from './backdrop'
import { Positioner } from './positioner'
import { Popup } from './popup'
import type { PositionerProps } from './positioner'

export interface ContentProps {
  children: React.ReactNode
  className?: string
  sideOffset?: number
  showBackdrop?: boolean
  showArrow?: boolean
  positionerProps?: Omit<PositionerProps, 'children'>
}

export function Content({ children, className, sideOffset = 4, showBackdrop = true, positionerProps }: ContentProps) {
  return (
    <Portal>
      {showBackdrop && <Backdrop />}
      <Positioner sideOffset={sideOffset} {...positionerProps}>
        <Popup className={className}>{children}</Popup>
      </Positioner>
    </Portal>
  )
}
